import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import styles from './TournamentBlock.module.scss';
import parse from 'html-react-parser';
import { EBrandTextColor } from 'Libraries/typography.library';
import { useState } from 'react';
import { t } from 'i18next';
import useEmblaCarousel from 'embla-carousel-react';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';

/* TODO Refactor tournament table and change names for strapi */

const TournamentBlock = ({ prize_pool, leaderboard, custom_table, additional_custom_table }) => {
  const [toggleState, setToggleState] = useState(false);
  const [toggleStateCustom, setToggleStateCustom] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    startIndex: 0,
    loop: false,
    breakpoints: {
      '(min-width: 768px)': { active: false },
    },
  });

  const handleClick = toggleStatus => {
    setToggleStateCustom(toggleStatus);
    emblaApi.scrollTo(toggleStatus, true);
  };

  return (
    <>
      {prize_pool && leaderboard && !custom_table && (
        <>
          <div className={`${styles.toggle_tournament} d-fl jc-c`}>
            <button
              className={`${!toggleState ? styles.toggle_tournament__btn_active : ''} ${styles.toggle_tournament__btn}`}
              onClick={() => setToggleState(false)}
            >
              {prize_pool?.title}
            </button>
            <button
              className={`${toggleState ? styles.toggle_tournament__btn_active : ''} ${styles.toggle_tournament__btn}`}
              onClick={() => setToggleState(true)}
              type="button"
            >
              {leaderboard?.title}
            </button>
          </div>
          {!toggleState && (
            <div className={styles.tournament_container}>
              <div className={styles.tournament_container__block}>{parse(prize_pool?.table)}</div>
            </div>
          )}
          {toggleState && (
            <div className={styles.tournament_container}>
              <div className={styles.tournament_container__block}>
                {leaderboard?.description && parse(leaderboard?.description)}
                {parse(leaderboard?.table)}
              </div>
            </div>
          )}
        </>
      )}

      {prize_pool && !leaderboard && !custom_table && (
        <div className={styles.prize_pool_container}>
          <div className={styles.prize_pool_container__block}>
            <div className={styles.prize_pool_container__title}>
              <div className={`${EComponentVisibility.MobileOnly}`}>
                <BaseText
                  value={prize_pool?.title}
                  size={EBaseTextSize.Title4}
                  color={EBrandTextColor.PurpleDark}
                  weight={EBaseTextWeight.W600}
                  alignment={EBaseTextPosition.Left}
                />
              </div>
              <div className={`${EComponentVisibility.TableteDesktop}`}>
                <BaseText
                  value={prize_pool?.title}
                  size={EBaseTextSize.Title3}
                  color={EBrandTextColor.PurpleDark}
                  weight={EBaseTextWeight.W600}
                  alignment={EBaseTextPosition.Center}
                />
              </div>
              {prize_pool?.description && (
                <div className={styles.prize_pool_container__description}>{parse(prize_pool?.description)}</div>
              )}
            </div>
            {parse(prize_pool?.table)}
          </div>
        </div>
      )}

      {prize_pool && leaderboard && custom_table && !additional_custom_table && (
        <>
          <div className={styles.prize_pool_container_custom}>
            <div className={styles.prize_pool_container_custom__block}>
              <div className={styles.prize_pool_container_custom__title}>
                <div className={`${EComponentVisibility.MobileOnly}`}>
                  <BaseText
                    value={t('tournament.prize.pool.title')}
                    size={EBaseTextSize.Title4}
                    color={EBrandTextColor.PurpleDark}
                    weight={EBaseTextWeight.W600}
                    alignment={EBaseTextPosition.Left}
                  />
                </div>
                <div className={`${EComponentVisibility.TableteDesktop}`}>
                  <BaseText
                    value={t('tournament.prize.pool.title')}
                    size={EBaseTextSize.Title3}
                    color={EBrandTextColor.PurpleDark}
                    weight={EBaseTextWeight.W600}
                    alignment={EBaseTextPosition.Center}
                  />
                </div>
              </div>
              <div className={`${styles.toggle_tournament_custom} d-in-fl jc-c`}>
                <div className={styles.toggle_tournament_custom__container}>
                  <div
                    className={`${toggleStateCustom == 0 && styles.toggle_tournament_custom__btn_active} ${
                      styles.toggle_tournament_custom__btn
                    }`}
                    onClick={() => setToggleStateCustom(0)}
                  >
                    {prize_pool.title}
                  </div>
                  <div
                    className={`${toggleStateCustom == 1 && styles.toggle_tournament_custom__btn_active} ${
                      styles.toggle_tournament_custom__btn
                    }`}
                    onClick={() => setToggleStateCustom(1)}
                  >
                    {leaderboard.title}
                  </div>
                  <div
                    className={`${toggleStateCustom == 2 && styles.toggle_tournament_custom__btn_active} ${
                      styles.toggle_tournament_custom__btn
                    }`}
                    onClick={() => setToggleStateCustom(2)}
                  >
                    {custom_table.title}
                  </div>
                </div>
              </div>
              <div className={styles.custom_table}>
                {toggleStateCustom == 0
                  ? parse(prize_pool?.table)
                  : toggleStateCustom == 1
                  ? parse(leaderboard?.table)
                  : parse(custom_table?.table)}
              </div>
            </div>
          </div>
        </>
      )}

      {prize_pool && leaderboard && custom_table && additional_custom_table && (
        <>
          <div className={styles.prize_pool_container_custom}>
            <div className={styles.prize_pool_container_custom__additional_block}>
              {prize_pool.description.length > 0 && (
                <div className={styles.prize_pool_container_custom__title}>{parse(prize_pool?.description)}</div>
              )}
              <div className={`${styles.toggle_tournament_custom} d-in-fl jc-c`}>
                <div className={styles.toggle_tournament_custom__additional_container}>
                  <div className={styles.embla} ref={emblaRef}>
                    <div className={styles.embla__container}>
                      <div className={styles.embla__slide} key={`wrapper-1`}>
                        <div
                          className={`${
                            toggleStateCustom == 0 && styles.toggle_tournament_custom__additional_container__btn_active
                          } ${styles.toggle_tournament_custom__additional_container__btn}`}
                          onClick={() => handleClick(0)}
                        >
                          {prize_pool.title}
                        </div>
                      </div>
                      <div className={styles.embla__slide} key={`wrapper-2`}>
                        <div
                          className={`${
                            toggleStateCustom == 1 && styles.toggle_tournament_custom__additional_container__btn_active
                          } ${styles.toggle_tournament_custom__additional_container__btn}`}
                          onClick={() => handleClick(1)}
                        >
                          {leaderboard.title}
                        </div>
                      </div>
                      <div className={styles.embla__slide} key={`wrapper-3`}>
                        <div
                          className={`${
                            toggleStateCustom == 2 && styles.toggle_tournament_custom__additional_container__btn_active
                          } ${styles.toggle_tournament_custom__additional_container__btn}`}
                          onClick={() => handleClick(2)}
                        >
                          {custom_table.title}
                        </div>
                      </div>
                      <div className={styles.embla__slide} key={`wrapper-4`}>
                        <div
                          className={`${
                            toggleStateCustom == 3 && styles.toggle_tournament_custom__additional_container__btn_active
                          } ${styles.toggle_tournament_custom__additional_container__btn}`}
                          onClick={() => handleClick(3)}
                        >
                          {additional_custom_table.title}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.additional_custom_table}>
                {toggleStateCustom == 0
                  ? parse(prize_pool?.table)
                  : toggleStateCustom == 1
                  ? parse(leaderboard?.table)
                  : toggleStateCustom == 2
                  ? parse(custom_table?.table)
                  : parse(additional_custom_table?.table)}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TournamentBlock;
